<template>
  <v-container fluid class="px-5">
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>
    <!-- SNACKBAR -->

    <v-dialog v-model="dialog" persistent max-width="550px">
      <v-card>
        <v-form ref="fPosiciones">
          <v-card-title class="px-4 py-6">
            <span class="text-h5">Datos de la Posición</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="2" class="py-0 px-1 ma-0">
                  <v-text-field
                    v-model.trim="selectedPosition.codigo"
                    label="Código"
                    :rules="requiredRule"
                    dense
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="10" class="py-0 px-1 ma-0">
                  <v-text-field
                    v-model.trim="selectedPosition.posicion"
                    label="Departamento"
                    dense
                    :rules="requiredRule"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0 pt-2 px-1 ma-0">
                  <v-textarea
                    outlined
                    no-resize
                    dense
                    rows="3"
                    :rules="requiredRule"
                    v-model.trim="selectedPosition.descripcion"
                    label="Descripción"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-4 pb-4 pt-0">
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text outlined @click="limpiar">
              Cerrar
            </v-btn>
            <v-btn color="blue darken-1" dark @click="guardar"> Guardar </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-row justify="space-between" align="center">
      <v-col cols="12">
        <h2 class="px-3">Posiciones de Empleados</h2>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <v-row align="center" justify="center" class="pt-4 pb-1">
      <v-spacer></v-spacer>

      <v-col cols="12" md="1" class="text-right pt-0">
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              color="primary"
              dark
              :block="$vuetify.breakpoint.smAndDown"
              @click="listar"
            >
              Listar
            </v-btn>
          </template>
          <span>Listar</span>
        </v-tooltip>
      </v-col>
      <v-col class="pt-0" cols="12" md="1">
        <v-tooltip bottom color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              color="green"
              :block="$vuetify.breakpoint.smAndDown"
              dark
              @click="downloadReporte"
            >
              <v-icon>fas fa-file-download</v-icon>
            </v-btn>
          </template>
          <span>Descargar</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <v-row>
      <v-col cols="12">
        <v-stepper non-linear v-model="step">
          <v-stepper-header>
            <v-stepper-step editable step="1"> Posiciones</v-stepper-step>
            <v-divider></v-divider>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-row>
                <v-col class="pt-0 pl-4" cols="12" md="4">
                  <v-text-field
                    class="text-xs-center"
                    v-model="search"
                    dense
                    append-icon="search"
                    label="Búsqueda"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="2" class="pt-0 pl-4">
                  <v-btn
                    class="mx-2"
                    dark
                    color="primary"
                    @click="dialog = true"
                  >
                    Agregar
                    <v-icon dark small class="pl-1"> fa-plus </v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-data-table
                :headers="headerGeneral"
                :items="posiciones"
                :loading="loader"
                loading-text="Listando Datos..."
                no-data-text="No se encontraron resultados..."
                :search="search"
                class="elevation-2"
              >
                <template v-slot:[`item.opciones`]="{ item }">
                  <v-icon class="mr-4" @click="verDetalles(item)"> tab </v-icon>
                </template>
              </v-data-table>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";

export default {
  name: "PosicionesMarcaciones",
  data() {
    return {
      step: 1,
      snack: false,
      requiredRule: [(v) => (v && !/\s/.test(v)) || "Campo obligatorio"],
      selectedPosition: {
        id: null,
        posicion: null,
        codigo: null,
        descripcion: null,
      },
      dialog: false,
      snackColor: "primary",
      snackTime: 4000,
      snackText: "Notification",
      posiciones: [],
      loader: false,
      search: "",
      headerGeneral: [
        {
          text: "Código",
          value: "codigo",
          width: 130,
          align: "center",
          sortable: true,
        },
        {
          text: "Posición",
          value: "posicion",
          align: "center",
          width: 350,
          sortable: true,
        },
        {
          text: "Descripción",
          value: "descripcion",
          align: "center",
          sortable: true,
        },
        {
          text: "Opciones",
          value: "opciones",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  created() {
    const tienePermiso = this.$store.state.permisos.some(
      (permiso) => permiso.nombre_modulo == "Marcaciones"
    );

    if (!tienePermiso) {
      this.$router.go(-1);
    }

    this.listar();
  },
  computed: {},
  methods: {
    nuevo() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.$refs.fPosiciones.validate()) {
        axios
          .post(
            "api/Marcaciones/Position",
            this.selectedPosition,
            configuracion
          )
          .then((res) => {
            this.snackText = "Nuevo Registro Creado!";
            this.snackColor = "primary";
            this.snack = true;

            this.limpiar();
            this.listar();
          })
          .catch((err) => {
            console.error(err);

            this.snackText = "No se Pudo Crear El Registro";
            if (err.response.status == 400 || err.response.status == 404) {
              this.snackText = err.response.data;
            } else {
              this.snackText = "No se Pudo Crear El Registro";
            }

            this.snackColor = "error";
            this.snack = true;
          });
      } else {
        this.snackText = "Complete los Campos Necesarios";
        this.snackColor = "error";
        this.snack = true;
      }
    },
    actualizar() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.$refs.fPosiciones.validate()) {
        axios
          .put(
            `api/Marcaciones/Position/${this.selectedPosition.id}`,
            this.selectedPosition,
            configuracion
          )
          .then((res) => {
            this.snackText = "Registro Actualizado!";
            this.snackColor = "primary";
            this.snack = true;

            this.limpiar();
            this.listar();
          })
          .catch((err) => {
            console.error(err);

            this.snackText = "No se Pudo Actualizar el Registro";
            if (err.response.status == 400 || err.response.status == 404) {
              this.snackText = err.response.data;
            } else {
              this.snackText = "No se Pudo Actualizar el Registro";
            }

            this.snackColor = "error";
            this.snack = true;
          });
      } else {
        this.snackText = "Complete los Campos Necesarios";
        this.snackColor = "error";
        this.snack = true;
      }
    },
    guardar() {
      if (!this.selectedPosition?.id) {
        this.nuevo();
      } else {
        this.actualizar();
      }
    },
    limpiar() {
      this.selectedPosition = {
        id: null,
        posicion: null,
        codigo: null,
        descripcion: null,
      };

      this.dialog = false;

      if (this.$refs.fPosiciones) {
        this.$refs.fPosiciones.resetValidation();
      }
    },
    verDetalles(item) {
      this.selectedPosition = { ...item };
      this.dialog = true;
    },
    listar() {
      this.loader = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/Marcaciones/Position", configuracion)
        .then((res) => {
          this.posiciones = res.data;
        })
        .catch((err) => console.error(err))
        .finally(() => (this.loader = false));
    },
    downloadReporte() {
      const workbook = XLSX.utils.book_new();

      const data = XLSX.utils.json_to_sheet(this.posiciones);
      XLSX.utils.book_append_sheet(workbook, data, "Posiciones");

      const filename = "Posiciones.xlsx";
      XLSX.writeFile(workbook, filename);
    },
  },
};
</script>
